import { ModalContent as ModalContent$2, Header, Top, Heading, CloseButton, HeaderContent, Content } from './Modal.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import Icon from '../Icon/Icon.js';
import { ICON_UI_CLOSE } from '../../icons/ICON_UI_CLOSE.js';

var ModalContent = function ModalContent(_ref) {
  var children = _ref.children,
    _ref$headerContent = _ref.headerContent,
    headerContent = _ref$headerContent === void 0 ? null : _ref$headerContent,
    _ref$heading = _ref.heading,
    heading = _ref$heading === void 0 ? null : _ref$heading,
    _ref$onClose = _ref.onClose,
    onClose = _ref$onClose === void 0 ? null : _ref$onClose,
    _ref$overlaidCloseBut = _ref.overlaidCloseButton,
    overlaidCloseButton = _ref$overlaidCloseBut === void 0 ? false : _ref$overlaidCloseBut,
    _ref$isInDrawer = _ref.isInDrawer,
    isInDrawer = _ref$isInDrawer === void 0 ? false : _ref$isInDrawer,
    _ref$noContentPadding = _ref.noContentPadding,
    noContentPadding = _ref$noContentPadding === void 0 ? false : _ref$noContentPadding;
  return /*#__PURE__*/jsxs(ModalContent$2, {
    children: [/*#__PURE__*/jsxs(Header, {
      children: [(heading || onClose) && /*#__PURE__*/jsxs(Top, {
        // @ts-ignore
        $hasHeading: !!heading,
        $overlaidCloseButton: overlaidCloseButton,
        $isInDrawer: isInDrawer,
        children: [heading && /*#__PURE__*/jsx(Heading, {
          id: "modal-heading",
          children: heading
        }), onClose && /*#__PURE__*/jsx(CloseButton, {
          // @ts-ignore
          $overlaidCloseButton: overlaidCloseButton,
          "aria-label": "close modal",
          lang: "en",
          onClick: onClose,
          type: "button",
          children: /*#__PURE__*/jsx(Icon, {
            path: ICON_UI_CLOSE,
            size: "s"
          })
        })]
      }), /*#__PURE__*/jsx(HeaderContent, {
        children: headerContent
      })]
    }), /*#__PURE__*/jsx(Content, {
      // @ts-ignore
      $noContentPadding: noContentPadding,
      $overlaidCloseButton: overlaidCloseButton,
      children: children
    })]
  });
};
var ModalContent$1 = ModalContent;

export { ModalContent$1 as default };
//# sourceMappingURL=ModalContent.js.map
